export default __webpack_public_path__ + "static/media/SchraderLogoWhite.179895a0.svg";